<template>
    <div
        class="t-cms"
        v-html="body"
        v-view.once
    >
    </div>
</template>

<script>
export default {
    name: 'block-body',
    props: {
        body: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>

    div {
        opacity: 0;
        transform: translate(0, 1em);

        &.view-in {
            opacity: 1;
            transform: translate(0);
            transition: opacity .4s $out-sine, transform .4s $out-expo;
        }
    }
</style>
